window.render_results_of_sign_validation = function(data,token){

    for (var i = 0; i <= data.firmas.length - 1; i++) {
        var firmado_por = "",profesion="", organization= "", organization_unit= "", email= "", cert_por= "", sellado_tiempo= "";
        if (data.firmas[i].firma_digital) {
            if (data.firmas[i].firma_digital.titular) {
                profesion = data.firmas[i].firma_digital.profesion
                firmado_por = data.firmas[i].firma_digital.titular.split(",").filter(s => s.includes('CN=')).toString().replace("CN=", "")
                organization = data.firmas[i].firma_digital.titular.split(",").filter(s => s.includes('O=')).toString().replace("O=", "")
                organization_unit = data.firmas[i].firma_digital.titular.split(",").filter(s => s.includes('OU=')).map(function (x) {
                    return x.replace("OU=", "")
                }).join(",");
                email = data.firmas[i].firma_digital.titular.split(",").filter(s => s.includes('EMAILADDRESS=')).toString().replace("EMAILADDRESS=", "")
            }
        }
        if (data.firmas[i].firma_digital) {
            if (data.firmas[i].firma_digital.autoridad_certificacion) {
                cert_por = data.firmas[i].firma_digital.autoridad_certificacion.split(",").filter(s => s.includes('CN=')).toString().replace("CN=", "")
            }
        }
        if (data.firmas[i].sello_tiempo) {
            var timeStamp = data.firmas[i].sello_tiempo.autoridad_sello_tiempo.split(",").filter(s => s.includes('CN=')).toString().replace("CN=", "")
            var timeStampO = data.firmas[i].sello_tiempo.autoridad_sello_tiempo.split(",").filter(s => s.includes('O=')).toString().replace("O=", "").replace('"', "")
            var timeStampC = data.firmas[i].sello_tiempo.autoridad_sello_tiempo.split(",").filter(s => s.includes('C=')).toString().replace("C=", "")
            sellado_tiempo = `Sellado de tiempo <i class=\"fa fa-check green\"></i><br>

      <span style="padding-left:20px">Autoridad: <b>${timeStamp}</b></span><br>
      <span style="padding-left:20px">Orgranización: <b>${timeStampO}</b></span><br>
      <span style="padding-left:20px">País: <b>${timeStampC}</b></span><br>
      <span style="padding-left:20px">Fecha: <b>${formatDate(data.firmas[i].sello_tiempo.fecha_hora)}</b><br>
      <span style="padding-left:20px">Válido hasta: <b>${formatDate(data.firmas[i].sello_tiempo.vigencia_fin)}</b><br>
        <span style="padding-left:20px">Válido INDECOPI: <b>${data.firmas[i].sello_tiempo.validacion_indecopi_tsl ? "SI" : "NO"}</b></span><br>
      <span style="padding-left:20px">Observación INDECOPI: <b>${data.firmas[i].sello_tiempo.validacion_indecopi_tsl_error ? data.firmas[i].sello_tiempo.validacion_indecopi_tsl_error : ""}</b></span>
   `;
        }
        var html = `<tr>
                                <td style="width: 50%;">
                                    ${firmado_por ? "Firmado por: <b>" + firmado_por + "</b><br>" : ""}
                                    ${profesion ? "Título: <b>" + profesion + "</b><br>" : ""}
                                    ${cert_por ? "Certificado emitido por: <b>" + cert_por + "</b><br>" : ""}
                                    ${organization ? "Organización: <b>" + organization + "</b><br>" : ""}
                                    ${organization_unit ? "Unidad organizacional: <b>" + organization_unit + "</b><br>" : ""}
                                    ${email ? "Email: <b>" + email + "</b><br>" : ""}
                                    ${data.firmas[i].firma_digital.fecha_hora ? "Fecha de firma: <b>" + formatDate(data.firmas[i].firma_digital.fecha_hora) + "</b><br>" : ""}
                                    ${sellado_tiempo ? sellado_tiempo : ""}
                                    </li>
                                </td>
                                 <td style="width: 50%">
                                   <ul class="vertical menu">
                                    <li>
                                    ${data.firmas[i].integridad ? "Integridad (Documento no adulterado): <i class=\"fa fa-check green\"></i>" : "Integridad (Documento no adulterado): <i class=\"fa fa-times\"></i> <span class='red'>" + data.firmas[i].integridad_error + ".</span>"}

                                    </li>
                                    <li>
                                    Valido INDECOPI: ${data.firmas[i].firma_digital.validacion_indecopi_tsl ? " <i class=\"fa fa-check green\"></i>" : " <i class=\"fa fa-times\"></i> <span class='red'>" + (data.firmas[i].firma_digital.validacion_indecopi_tsl_error != null ? data.firmas[i].firma_digital.validacion_indecopi_tsl_error + "." : "") + "</span>"}
                                    </li>
                                     <li>
                                     Valido CRL: ${data.firmas[i].firma_digital.validacion_revocacion ? " <i class=\"fa fa-check green\"></i>" : " <i class=\"fa fa-times\"></i> <span class='red'>" + (data.firmas[i].firma_digital.validacion_revocacion_error != null ? data.firmas[i].firma_digital.validacion_revocacion_error + "." : "") + "</span>"}
                                    </li>
                                    <li>
                                      ¿La firma cubre todo el documento?: ${data.firmas[i].firma_digital.cubre_todo_documento ? "<i class=\"fa fa-check green\"></i>" : "<i class=\"fa fa-times\"></i>"}
                                    </li>
                                    </ul>
                                </td>
                              </tr>`
        $(".resultados-" + token).css("display", "table")

        $(".resultados-" + token + " tbody").append(html);
        $(document).foundation();
    }
}

window.render_results_of_sign_validation_v2 = function(data,token){
    var html = "";
    if(!data.firmas){
        html = "<h3 class='bold'>"+ data.error +"</h3>" + html;
        $(".validador-pdf-content-" + token).html(html);
        $(document).foundation();
        return;
    }
    var ico_firma = "data:@file/png;base64,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";
    var ico_timestamp = "data:@file/png;base64,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";
    var ico_OK = "data:@file/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAE+UlEQVRoge2ZW2wUVRjHf9+ZotDGSygUUGlKmggFQaVcLL1IJRG6hRYf6iUmhhgiDyYaoIXXfbS0JdHEN58wxgiJ4VZWJXJpl5tRgiBSeTAYNZKWEmMpiN09nw+9LbszuzvNLBrC/23Od/v/Z845880ZuI97GDui9c3t3XVbc1lDcpW4rav+VUQ/AUTRDduqI7tyUScnAlqj9bVGNQI8ODI0JCrrmms6vwy6lm8BHcdfnB03eccEDorYPTcqnzsZlrAdte88HloYN3QBjyaFDqg6K7fVHDibOPhedPUCR50moMnGdPX22shvORXQFg29jPJZwtAfwH6FvcZxrmg8fhSY6RF+VRyn1sbjJQLrgQZgVgKbV1qqDu32wyfPJ39UWZGkehawSWCTxuOZwmdqPH7J865ZrQB8CTB+nEcCKvzGZA0R37l9TaGdJ5umxOODfwIP+C2UJYYcp+CRLSv23Mo2wNcTsHagnNyRB5gUi91Y7CcgqycQPrpycr4zpRyRtwVemxi37KDwKaof3ozf+i5ce+zvTP6uAlqjDY8ZHSoHKkGqgHJgcsBcMyEGXFY0CpyYhIluru78OdnJdRcyGjsCMjfXDDMgD5gvyHzgrRjaA5QlO7muAYF9OSaXgvwpBRk81JWTuwArd1VA4dRpLH22gtKSJ72djJO9gIGapaeBq4Gwy4DCqdN4at4zGGMofqLES0Tv4IolZ9wMrgLCEraCHAqSqBumFxaxsGyY/ChmP15MQX7KdDqQ2G8lwvM9IJLbdVA4dRrz5y5CZJyCquViz3kGbw4mebvPf0jTC1kbv4L47jSywvTCIhbMcyff19+bGqD6i1cuV4at0dASxBwOgGsKfJMHQI60nVjr2ielCOjoWrPKKF8DRYEwTsDEyAMihVh7uD1aV5dsukNAe7TudSsmAjycDaHMe/c4Jkx+HAWqsn9Hd92biYNj2dq7Q++qyi5gUjbZSopLWba4gumFmR9UAORHkSfIR23d9dtTBPhBSXEpc4pLETEsmLcorYgAybtiLGtz9aH3RfQNYChdQEF+ASWz54xdpxORA/IxRTe2VHe2jtVP9ujoWrPKivmcNOsg8e2ZwIyLly/Q23c1V+QHRbSpuSoSSRz0aKdDS4zSSZqdKJ0ItTZY8qr9OM66lsqDp5JNnh80bV1rFiHm+3R5ve4yEOycV/t0S80X591MaRaxmeNtG0Zffy8XLp3D2vE2RcQEvmCNcUo8bZ5RQmM2yfuvX+OHnjtFjCKo3UbVm4t7N6phoxDKtoCbiCC3SkXX7t7d5LjZXAXkd5+pEJjhp0iiiCDJj6Do1xk3l7sZXLtRMdKI+q/Sf/0aP/40vNYCJA+AGm0ETiaPu68BpWGihfr6ewMnD6Dwktu46xOwkvfC//FYxc3p3jzY8sKOrrpKEXG9E0HBWKnc+nxnylz39PeTfPINvgVu+2aVPf4ZsINnM7uNw5eAd0KR28A5X5R8QOFsNtMmEf6/B1RTGqrAIPjO7V+AkeQi14CPQRvEccoY/uXkhT5xnDIRWw18APx+h1VTcmeE719MJh47ZU1eD+g+I+wdqFz+TeKhU8fxunpr5Bip3xN/Gaurt1Yf6Bm5joY1vPmhE2eWWWU9SKNjh0775XPXfrOq0bXbKiNfBV0rJydX26s6j6KyAbCAKroxF+Rzjrbu0Ja27tCW/5rHfeQS/wK8sC5IUQE8VAAAAABJRU5ErkJggg==";
    var ico_Error = "data:@file/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAChUlEQVRoge2YT2sTQRjGf9Nmd6NFIlHx4EUQPbR48AOIVtFDUD9Bj6LFPwj2JngRBMFiBC9+Bc+CJ8GmQu9SAoIEL7UgDShEoWnavF7aZLvN7szszlbB/Z2WzOy8z5tn5mESKCgoKCj4n1F5LSwLwRUUrwHoq9tqev19HnVyaUCWqNIrfwGpbn/0k75/Wk132q5rjbleEIBe8DQkHuAw4xtP8ijl3AFZ9CcR9QkoRYa2QM6pCxvLLuu5d0BUnb3iAcZBvXRdzmkD0ghuAFcTplySheC6y5rOtpA08WkHy8AZTcUWv7pTqkbXRV13DrSD++jEAwinOBjcdVXWiQMjYlOHs1h148De2NThLFYzOxAXmw/mp/jR8QA4UulRf9iMvuokVrM7EBObXqk/ePa9fnQYHMVqpgaSYtP3ZPAcbiZC5lhN3YA08YHncePhbz3czAgFdXlHkFZHegc0semVhqL9eAcyx2qqBmSJKqhHSXN2O5DQAIDisXw4dDSNlnQOGMRmWLSnayBDrFo3IIv+JHBTNy+8bfxSwhkYLMwtafhnbfXYOxB/29yF8RkYkipWrRowuG0OsDoDQ6xj1bgBXWxGsTwDYUVWsWrugOltc5uwaM/kDOxgGatGd6EUt82sGN9WzRywv21mxThWtQ4k/EhP5Ntambcfj6OAa+e/c+LYus3rYHhb1YsyjM0or96cZHWtDMDX1QM8u/fZdomdWL2cNClxC9nEZpTOb2/ksyXaWI1twDY2o8zUVqhMbFKZ2GSmtpJ2GW2sxp4BaQRzwHz6yg4R5tTF7otRQ0lb6E5OcuwZi9eSz3+j+0h8A8IsitY+ahmNosWWmv3bMgoKCgoK/k3+AILkzValVvu5AAAAAElFTkSuQmCC";
    var cantidad_firmas = data.firmas.length == 1 ? "1 firma digital" : (data.firmas.length) + " firmas digitales";

    for (var i = 0; i <= data.firmas.length - 1; i++) {
        var item = data.firmas[i];
        var cubre = data.firmas[data.firmas.length -1].cubre_todo_documento;
        html = html + `<ul class="accordion validador-pdf" style="margin-bottom: 0;" data-accordion data-allow-all-closed="true">
        <li class="accordion-item" data-accordion-item>
          <!-- Accordion tab title -->
          <a href="#" class="accordion-title" style="padding: 0.5rem 1.2rem">
          
            <img data-tooltip tabindex="1" title="${item.tipo == "firma_digital" ? "Firma digital" : "Sello de tiempo"}" style="width: 25px" src="${item.tipo == "firma_digital" ? ico_firma : ico_timestamp}" />

            <b id="validar-titulo">${item.detalle}</b>
            <img  style="width: 25px;right: 5px;top: 5px;position: absolute;" src="${item.integridad ? ico_OK : ico_Error}" />

          </a>

          <!-- Accordion tab content: it would start in the open state due to using the \`is-active\` state class. -->
          <div class="accordion-content" data-tab-content>
            <table style="margin:5px;word-break: break-all;" class="small">
              <thead>
              <tr>
                <th colspan="2" class="text-center">Información de la firma</th>
              </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 40%; " class="bold">
                    Estado de la firma
                  </td>
                  <td style="${item.integridad ? "" : "color:red;font-weight:bold"}">
                    ${item.integridad ? "VÁLIDA" : (item.integridad_error)}
                  </td>
                </tr>
                <tr>
                  <td class="bold">
                    Formato y nivel
                  </td>
                  <td >
                    ${item.formato}
                  </td>
                </tr>
                <tr>
                  <td class="bold">
                    Fecha y hora
                  </td>
                  <td >
                    ${formatDate(item.fecha_hora)}
                  </td>
                </tr>
                <tr>
                  <td class="bold">
                    Algoritmo resumen
                  </td>
                  <td >
                    ${item.algoritmo_resumen}
                  </td>
                </tr>
               
                <tr>
                  <td class="bold">
                    ¿Cubre todo el documento?
                  </td>
                  <td>
                    ${cubre ? "SI" : "NO"}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <b>Firma generada por</b>
                    <p>${item.titular}</p>
                  </td>
                 
                </tr>
              </tbody>
            </table>

            <table style="margin:5px;margin-top:25px;word-break: break-all;" class="small">
              <thead>
              <tr>
                <th colspan="2" class="text-center">Información del certificado</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td style="width: 40%" class="bold">
                  Número de serie
                </td>
                <td >
                  ${item.numero_serie}
                </td>
              </tr>
              <tr>
                <td class="bold">
                  Válido desde
                </td>
                <td >
                  ${formatDate(item.valido_desde)}
                </td>
              </tr>
              <tr>
                <td class="bold">
                  Válido hasta
                </td>
                <td >
                 ${formatDate(item.valido_hasta)}
                </td>
              </tr>
              <tr>
                <td class="bold">
                  Válido INDECOPI
                </td>
              <td style="${item.valido_indecopi_tsl ? "" : "color:red;font-weight:bold"}">
                  ${item.valido_indecopi_tsl ? "SI" : (item.valido_indecopi_tsl_error)}
                </td>
              </tr>
              <tr>
                <td class="bold">
                  Válido CRL
                </td>
              <td style="${item.valido_revocacion ? "" : "color:red;font-weight:bold"}">
                  ${item.valido_revocacion ? "SI" : (item.valido_revocacion_error)}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Ruta de certificación</b>
                  <p>${item.ruta_certificacion.join("<br>")}</p>
                </td>

              </tr>

              </tbody>
            </table>
          </div>
        </li>
      </ul>`

    }
    if(data.firmas){
        if(data.firmas.length > 0){
            html = "<p class='bold'>" +  cantidad_firmas+"</p>" + html;
        }
        else{
            html = "<h3 class='bold'>No tiene firmas digitales</h3>" + html;
        }
    }
    else{
        html = "<h3 class='bold'>No tiene firmas digitales</h3>" + html;
    }
    $(".validador-pdf-content-" + token).html(html);
    $(document).foundation();
}

window.render_error_sign_validation_v2 = function(data,token){
    var html = "";
    if(data == null){
        //SI ES CATCH DE AJAX
        $(".loading-" + token).addClass("hide")
        var html = `<div class="text-center">
                                
                                   <h4>No se pudo validar la firma, intente mas tarde</h4>
                                   <p>Puedes firmar tu documento ahora mismo</p>
                                    <span class="button valid_os_sign" onclick="btnValidarOS();$('#validsign-${token}').foundation('close')" data-open="sign-${token}"><i class="fa fa-file-signature"></i> Firmar</span>
                                
                              </div>`
        $(".validador-pdf-content-" + token).html(html);
        return;
    }
    if(data.signature){
        // SI USABA VALIDACION ANTIGUA
        html =  `
                        <div class="text-center">
                            <h3 clas="bold red">Se encontraron ${data.signature.length} firmas</h3>
                            <h4>Por favor vuelve a validar las firmas, 
                            hemos mejorado el algoritmo de validación recientemente</h4>
                            <br>
                           <span class="button validar_firma" onclick="btnValidarFirma($(this),true)" data-token="${token}"><i class="fa fa-file-signature"></i> Validar de nuevo</span>
                           <p>Puedes firmar tu documento ahora mismo</p>
                            <span class="button valid_os_sign" onclick="btnValidarOS();$('#validsign-${token}').foundation('close')" data-open="sign-${token}"><i class="fa fa-file-signature"></i> Firmar</span>
                        </div>`;


    }
    else{
        html = `
                                <div class="text-center">
                                  <h3 clas="bold red text-center">${data.error == "Net::ReadTimeout" ? "No se pudo validar en este momento. Por favor, intente de nuevo" : data.error}</h3>
                                   <span class="button validar_firma" onclick="btnValidarFirma($(this))" data-token="${token}"><i class="fa fa-file-signature"></i> Validar de nuevo</span>
                                   <p>Puedes firmar tu documento ahora mismo</p>
                                    <span class="button valid_os_sign" onclick="btnValidarOS();$('#validsign-${token}').foundation('close')" data-open="sign-${token}"><i class="fa fa-file-signature"></i> Firmar</span>
                                </div>`
    }
    $(".validador-pdf-content-" + token).html(html);
}